import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';

import { JobSummaryItem } from '../Detail';

const styles = theme => ({
  root: {
    margin: theme.spacing.unit,
    width: '400px',
  },
});

const JobSummary = ({ classes }) => {
  return (
    <Card className={classes.root}>
      <CardHeader
        title="Job Summary"
        subheader="Summary of the job and actions for each category"
      />
      <CardContent>
        <div>
          <JobSummaryItem
            title="TASKS:"
            caption="some caption text 1"
            numItems={1}
          />
          <JobSummaryItem
            title="FILES:"
            caption="some caption text 2"
            numItems={2}
          />
          <JobSummaryItem
            title="NOTES:"
            caption="some caption text 3"
            numItems={4}
          />
          <JobSummaryItem
            title="PHOTOS:"
            caption="some caption text 4"
            numItems={7}
          />
          <JobSummaryItem
            title="INVOICES:"
            caption="some caption text 5"
            numItems={2}
          />
          <JobSummaryItem
            title="TIME CARDS:"
            caption="some caption text 6"
            numItems={5}
          />
          <JobSummaryItem
            title="RECEIPTS"
            caption="some caption text 7"
            numItems={99}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(JobSummary);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/JobSummary.jsx